import { useBrazilianMasks } from './useBrazilianMasks.js'

export function useInputMasks() {
  const {
    applyPhoneMask,
    applyDocumentMask,
    applyCpfMask,
    applyRgMask,
    applyCepMask,
    applyCurrencyMask,
    parseCurrencyToNumber,
    handlePhoneMaskInput,
    handleDocumentMaskInput,
    handleCpfMaskInput,
    handleRgMaskInput,
    handleZipMaskInput,
    handleCurrencyMaskInput
  } = useBrazilianMasks()

  return {
    applyPhoneMask,
    applyDocumentMask,
    applyCpfMask,
    applyRgMask,
    applyZipMask: applyCepMask,
    applyCurrencyMask,
    parseCurrencyToNumber,
    handlePhoneMaskInput,
    handleDocumentMaskInput,
    handleCpfMaskInput,
    handleRgMaskInput,
    handleZipMaskInput,
    handleCurrencyMaskInput,
    fetchAddressByCep: async (cep, form) => {
      try {
        const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
        const data = await response.json()
        
        if (data.logradouro) {
          form.address = data.logradouro
          form.neighborhood = data.bairro
          // CitySelectAsync precisa do city_id (FK) e um label para exibir.
          const stripAccents = (v) =>
            String(v || '')
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')

          const nameNoAccent = stripAccents(data.localidade).trim()
          const uf = String(data.uf || '').trim().toUpperCase()

          if (nameNoAccent && uf.length === 2) {
            const params = new URLSearchParams({ q: nameNoAccent.slice(0, 40) })
            params.set('uf', uf)
            const res = await fetch(`/api/v1/cities/search?${params.toString()}`)
            if (res.ok) {
              const payload = await res.json()
              const list = payload.cities || []
              const c = list[0]
              if (c) {
                form.city_id = c.id
                const fullLabel =
                  c.label ||
                  (c.uf ? `${c.display_name || c.name} - ${c.uf}` : c.display_name || c.name)
                if (form.city_label !== undefined) form.city_label = fullLabel
              }
            }
          }
        }
      } catch (error) {
        console.error('Erro ao buscar CEP:', error)
      }
    }
  }
}
